import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import { Title } from '@app/components/core/typography/Title'
import { Paragraph } from '@app/components/core/typography/Paragraph'
import { UnorderedList } from '@app/components/core/typography/UnorderedList'
import { BlockQuote } from '../typography/BlockQuote'
import { TextLink } from '../link/TextLink'

interface MarkdownProps {
  content: string
}

export const Markdown = ({ content }: MarkdownProps) => {
  return (
    <ReactMarkdown
      remarkPlugins={[remarkGfm]}
      components={{
        h1: ({ children }) => <Title.H1>{children}</Title.H1>,
        h2: ({ children }) => <Title.H2>{children}</Title.H2>,
        h3: ({ children }) => <Title.H3>{children}</Title.H3>,
        h4: ({ children }) => <Title.H4>{children}</Title.H4>,
        h5: ({ children }) => <Title.H5>{children}</Title.H5>,
        p: ({ children }) => <Paragraph.Medium>{children}</Paragraph.Medium>,
        ul: ({ children }) => <UnorderedList>{children}</UnorderedList>,
        blockquote: ({ children }) => <BlockQuote>{children}</BlockQuote>,
        a: ({ href, children }) => (
          <TextLink to={href || ''} externalURL target="_blank">
            {children}
          </TextLink>
        ),
      }}
    >
      {content}
    </ReactMarkdown>
  )
}
